/**
 * Creates a thumbnail from an image file for profile/logo uploads.
 * Used so list-users and get-user return small images and the server doesn't get overloaded.
 * @param {File} file - Image file from input
 * @param {number} maxDimension - Max width/height in pixels (default 96)
 * @param {number} jpegQuality - Quality for JPEG output 0–1 (default 0.85)
 * @return {Promise<{ blob: Blob, bytes: Uint8Array }>}
 */
export function createProfileThumbnail(file, maxDimension = 96, jpegQuality = 0.85) {
  return new Promise((resolve, reject) => {
    const imageUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const scale = Math.min(1, maxDimension / Math.max(img.width, img.height));
        const targetWidth = Math.max(1, Math.round(img.width * scale));
        const targetHeight = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          URL.revokeObjectURL(imageUrl);
          reject(new Error("Canvas not supported"));
          return;
        }
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(
          (blob) => {
            URL.revokeObjectURL(imageUrl);
            if (!blob) {
              reject(new Error("Failed to create thumbnail"));
              return;
            }
            blob.arrayBuffer().then((buffer) => {
              const bytes = new Uint8Array(buffer);
              console.log("THUMB NAIL SIZE OF IMAGE", bytes.length);
              resolve({ blob, bytes });
            });
          },
          "image/jpeg",
          jpegQuality
        );
      } catch (err) {
        URL.revokeObjectURL(imageUrl);
        reject(err);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(imageUrl);
      reject(new Error("Failed to load image"));
    };
    img.src = imageUrl;
  });
}
